import baseRandom from './_baseRandom.js';

/**
 * A specialized version of `_.sample` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @returns {*} Returns the random element.
 */
function arraySample(array) {
  var length = array.length;
  return length ? array[baseRandom(0, length - 1)] : undefined;
}

export default arraySample;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_arraySample.js
// module id = 640
// module chunks = 0